<template>
  <div class="box">
    <div class="top">
      <div class="top_left">
        <img class="logo" src="./assets/logo.png">
        <img class="font" src="./assets/font.png">
      </div>
      <div class="top_right">
        <div :class="topIndex === index ? 'select_in' : ''" class="top_right_item" v-for="(item, index) in selectList"
          :key="index" @click="handleClick(index)">{{ item }}</div>
        <div class="search_box" v-if="topIndex === 2 || topIndex === 3">
          <img class="search" src="./assets/search.png" @click="ifSearch = true">
          <input placeholder="查询" v-model="searchText" @input="handleInput" v-if="ifSearch"
            style="width: 150px;box-sizing: border-box;">
          <div style="width: 150px;" v-else></div>
        </div>
        <div class="search_box" v-else>
          <div class="search"></div>
          <div style="width: 150px;box-sizing: border-box;"></div>
        </div>
      </div>
    </div>

    <div class="swiper" v-if="topIndex == 0">
      <div class="swiper_container">
        <div class="swiper_slide" v-for="(item, index) in bannersList" :key="index"
          :class="{ active: currentSlide === index }">
          <div class="slide_background">
            <img :src="item.image" class="slide_image" />
            <div class="slide_overlay"></div>
          </div>
        </div>
        <!-- 分页指示器 -->
        <div class="swiper_pagination">
          <div v-for="(slide, index) in bannersList" :key="index"
            :class="currentSlide === index ? 'pagination_dot active' : 'pagination_dot'" @click="goToSlide(index)">
          </div>
        </div>
      </div>
    </div>

    <img class="bg_img" src="./assets/bg11.png" v-if="topIndex == 1">
    <img class="bg_img" src="./assets/bg12.png" v-if="topIndex == 3">
    <img class="bg_img" src="./assets/bg13.png" v-if="topIndex == 2 && whichProduct == null">
    <img class="bg_img" src="./assets/bg14.png" v-if="topIndex == 4">


    <div class="about" v-if="topIndex == 0 || topIndex == 1">
      <div class="about_top">
        <div class="about_left">
          <img class="about_building" :src="aboutUs.main_image" />
        </div>
        <div class="about_right">
          <div class="about_title">{{ aboutUs.title }}</div>
          <div class="about_subtitle">{{ aboutUs.company_name }}</div>
          <div class="about_line"></div>
          <div class="about_content">
            <p>
              {{ aboutUs.description }}
            </p>
          </div>
          <img class="about_more1" src="./assets/more2.png" @click="topIndex = 1" v-if="topIndex == 0" />
        </div>
      </div>
      <div class="about_bottom">
        <div class="about_bottom_title">核心业务板块</div>
        <div class="business_cards">
          <div class="business_card" v-for="(item, index) in segmentsList" :key="index" @mouseover="onSegments(index)">
            <img :src="item.image" class="card_image" />
            <div class="business_card_content"
              :style="onSegmentsIndex === index ? 'background: linear-gradient( 180deg, rgba(61,100,81,0) 0%, #3D6451 100%)' : ''">
              <div class="card_title"
                :style="onSegmentsIndex === index ? '' : 'position: absolute;bottom: 34px;left: 50%;transform: translate(-50%, 0);'">
                {{ item.title }}</div>
              <div class="card_text" v-if="onSegmentsIndex === index">{{ item.description }}</div>
              <img class="about_more" src="./assets/more1.png" v-if="onSegmentsIndex === index" />
            </div>
          </div>
        </div>
      </div>
    </div>


    <div class="values" v-if="topIndex == 1">
      <div class="values_container">
        <div class="values_title">企业价值观</div>
        <div class="value_sections">
          <div class="value_section">
            <img style="width: 250px;height: 250px;" src="./assets/aboutUsimg/box3.png" />
            <div class="value_name">诚信</div>
            <div class="value_description">
              诚信是公司发展的基石。无论是对客户、合作伙伴还是员工，都始终坚守诚实守信的原则，从产品质量到服务承诺，都以诚信为本，赢得了广泛的信任和良好的口碑。
            </div>
          </div>
          <div class="value_section">
            <img style="width: 250px;height: 250px;" src="./assets/aboutUsimg/box2.png" />
            <div class="value_name">传承</div>
            <div class="value_description">
              传承中医药的悠久历史和丰富文化，积极传承中医药的经典理论、方剂和泡制技艺。通过对传统中医药的传承和弘扬，让古老的中医药在现代社会中焕发出新的生机与活力。
            </div>
          </div>
          <div class="value_section">
            <img style="width: 250px;height: 250px;" src="./assets/aboutUsimg/box1.png" />
            <div class="value_name">创新</div>
            <div class="value_description">
              创新是公司发展的动力源泉，在传承的基础上，不断引入现代科技和理念，对中医药产品和服务进行创新升级，从研发新技术、新产品到优化服务模式，不断探索中医药发展的新路径，以满足市场的不断变化和消费者日益增长的需求。
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="people" v-if="topIndex == 0 || topIndex == 1">
      <div class="people_container" v-for="item in peoplee" :key="item.id">
        <div class="expert_photo_frame">
          <img class="expert_photo" :src="item.main_image" />
        </div>
        <div class="people_right">
          <div class="expert_title">{{ item.title }}</div>
          <div class="expert_name">{{ item.name }}</div>
          <div class="expert_intro">
            {{ item.description }}
          </div>
          <!-- <div class="expert_separator"></div> -->
          <div class="about_line"></div>
          <div class="expert_details">
            <div class="expert_name">个人成就</div>
            <div class="expert_intro">
              {{ item.Individual_results }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="goods" v-if="(topIndex == 0 || topIndex == 2) && ifShowProduct"
      :style="topIndex == 0 ? '' : ' background: #F6F6F6;'">
      <div class="goods_container" :style="topIndex == 0 ? 'width: 1550px;' : ''">
        <div class="goods_title" v-if="topIndex == 0">产品展示</div>
        <div class="category_tabs">
          <div :class="categoriesIndex === index ? 'category_tab_active' : 'category_tab'"
            v-for="(item, index) in categories" :key="index" @click="selectCategory(index)">
            {{ item.name }}
          </div>
        </div>
        <div class="products_section">
          <img class="left_img" src="./assets/left.png" @click="prevProduct()" v-if="topIndex == 0" />
          <div class="products_container" style="flex-wrap: wrap;">
            <div v-for="(product, index) in products" :key="index" @click="selectProduct(product)" class="product_card">

              <div v-if="topIndex == 0">
                <div v-if="index <= 3">
                  <div class="product_image_container">
                    <img :src="product.images[0]" class="product_image" />
                  </div>
                  <div style="padding:0px 17px 28px">
                    <div class="product_name" style="margin-bottom: 8px;">{{ product.name }}</div>
                    <div class="product_des">{{ contentHtml(product.details) }}</div>
                  </div>
                </div>
              </div>
              <div v-else>
                <div class="product_image_container">
                  <img :src="product.images[0]" class="product_image" />
                </div>
                <div style="padding:0px 17px 28px">
                  <div class="product_name" style="margin-bottom: 8px;">{{ product.name }}</div>
                  <div class="product_des">{{ contentHtml(product.details) }}</div>
                </div>
              </div>
            </div>
            <div v-if="products.length == 0" style="text-align: center;width: 100%;">暂无产品</div>
          </div>
          <img class="left_img" src="./assets/right.png" @click="nextProduct()" v-if="topIndex == 0" />
        </div>
      </div>
      <div class="goods_pages" v-if="topIndex == 2">
        <img src="./assets/r2.png" style="width: 40px;height: 40px;" @click="projectsPrevPage()" />
        <!-- productsPerPageCount -->
        <div v-for="(item, index) in page" :key="index">

          <div v-if="index < productsPerPageCount && page - 5 <= index"
            style="width: 40px;height: 40px;border-radius: 50%;line-height: 40px;margin: 0px 20px;">
            <div v-if="productsCurrentPage === index + 1"
              style="background-color: #0F2419;border-radius: 50%;color: white;text-align: center;">{{ index + 1 }}
            </div>
            <div v-else>{{ index + 1 }}</div>
          </div>
        </div>
        <img src="./assets/r1.png" style="width: 40px;height: 40px;" @click="projectsNextPage()" />

      </div>
    </div>

    <div class="news" v-if="topIndex == 0 || (topIndex == 3 && newsId == null)">
      <div class="news_container" :style="topIndex == 0 ? '' : 'width:1380px;'">
        <div class="news_title" v-if="topIndex == 0">新闻资讯</div>
        <div class="news_cards" :style="topIndex == 0 ? '' : 'flex-wrap: wrap;'">
          <div v-for="(item, index) in newsList" :key="index" @click="lookNews(item)">
            <div v-if="topIndex == 0">
              <div v-if="index <= 2">
                <div class="news_card">
                  <div class="news_image_container">
                    <img :src="item.main_image" class="news_image" />
                  </div>
                  <div class="news_content">
                    <div style="height: 100px;">
                      <div class="news_article_title">{{ item.title }}</div>
                      <div class="news_article_description">{{ item.summary }}</div>
                    </div>
                    <div class="news_article_date">
                      {{ item.published_at }}
                      <div class="news_look">查看
                        <img class="news_look_icon" src="./assets/right.png" />
                      </div>
                    </div>

                  </div>
                </div>
              </div>
            </div>
            <div v-else>
              <div class="news_card" @click="lookNews(item)">
                <div class="news_image_container">
                  <img :src="item.main_image" class="news_image" />
                </div>
                <div class="news_content">
                  <div class="news_article_title">{{ item.title }}</div>
                  <div class="news_article_description">{{ item.summary }}</div>
                  <div class="news_article_date">
                    {{ item.published_at }}
                    <div class="news_look">查看
                      <img class="news_look_icon" src="./assets/right.png" />
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="goods_pages" v-if="topIndex == 3">
          <img src="./assets/r2.png" style="width: 40px;height: 40px;" @click="newsPrevPage()" />
          <div v-for="(item, index) in page" :key="index">

            <div v-if="index < newsPerPageCount && page - 5 <= index"
              style="width: 40px;height: 40px;border-radius: 50%;line-height: 40px;margin: 0px 20px">
              <div v-if="newsCurrentPage === index + 1"
                style="background-color: #0F2419;border-radius: 50%;color: white;text-align: center;">{{ index + 1 }}
              </div>
              <div v-else>{{ index + 1 }}</div>
            </div>

          </div>
          <img src="./assets/r1.png" style="width: 40px;height: 40px;" @click="newsNextPage()" />

        </div>

        <div class="news_more_btn" @click="handleClick(3)" v-if="topIndex == 2">
          <img class="news_more" src="./assets/more3.png" />
        </div>
      </div>
    </div>




    <div class="properties" v-if="topIndex == 1">
      <div class="properties_container">
        <!-- 产品特性部分 -->
        <div class="features_section">
          <div class="features_title">产品特性</div>
          <div class="features_cards">
            <div class="feature_card" @mouseover="whichSpac = 1">
              <img v-if="whichSpac != 1" style="width: 164px;height: 164px;" src="./assets/aboutUsimg/b1.png" />
              <img v-else style="width: 164px;height: 164px;" src="./assets/aboutUsimg/b1_1.png" />
              <div class="feature_label">传承性</div>
              <img v-if="whichSpac == 1" style="width: 240px;height: 180px;" src="./assets/aboutUsimg/text1.png" />
              <div v-else style="width: 240px;height: 180px;"></div>

            </div>
            <img style="width: 102px;height: 10px;margin: 75px 12px;" src="./assets/aboutUsimg/line.png" />
            <div class="feature_card" @mouseover="whichSpac = 2">
              <img v-if="whichSpac != 2" style="width: 164px;height: 164px;" src="./assets/aboutUsimg/b2.png" />
              <img v-else style="width: 164px;height: 164px;" src="./assets/aboutUsimg/b2_2.png" />
              <div class="feature_label">安全性</div>
              <img v-if="whichSpac == 2" style="width: 240px;height: 180px;" src="./assets/aboutUsimg/text2.png" />
              <div v-else style="width: 240px;height: 180px;"></div>

            </div>
            <img style="width: 102px;height: 10px;margin: 75px 12px;" src="./assets/aboutUsimg/line.png" />
            <div class="feature_card" @mouseover="whichSpac = 3">
              <img v-if="whichSpac != 3" style="width: 164px;height: 164px;" src="./assets/aboutUsimg/b3.png" />
              <img v-else style="width: 164px;height: 164px;" src="./assets/aboutUsimg/b3_3.png" />
              <div class="feature_label">有效性</div>
              <img v-if="whichSpac == 3" style="width: 240px;height: 180px;" src="./assets/aboutUsimg/text3.png" />
              <div v-else style="width: 240px;height: 180px;"></div>

            </div>
            <img style="width: 102px;height: 10px;margin: 75px 12px;" src="./assets/aboutUsimg/line.png" />
            <div class="feature_card" @mouseover="whichSpac = 4">
              <img v-if="whichSpac != 4" style="width: 164px;height: 164px;" src="./assets/aboutUsimg/b4.png" />
              <img v-else style="width: 164px;height: 164px;" src="./assets/aboutUsimg/b4_4.png" />
              <div class="feature_label">调养性</div>
              <img v-if="whichSpac == 4" style="width: 240px;height: 180px;" src="./assets/aboutUsimg/text4.png" />
              <div v-else style="width: 240px;height: 180px;"></div>

            </div>
            <img style="width: 102px;height: 10px;margin: 75px 12px;" src="./assets/aboutUsimg/line.png" />
            <div class="feature_card" @mouseover="whichSpac = 5">
              <img v-if="whichSpac != 5" style="width: 164px;height: 164px;" src="./assets/aboutUsimg/b5.png" />
              <img v-else style="width: 164px;height: 164px;" src="./assets/aboutUsimg/b5_5.png" />
              <div class="feature_label">方便性</div>
              <img v-if="whichSpac == 5" style="width: 240px;height: 180px;" src="./assets/aboutUsimg/text5.png" />
              <div v-else style="width: 240px;height: 180px;"></div>
            </div>
          </div>
        </div>

        <!-- 荣誉资质部分 -->
        <div class="honors_section">
          <div class="honors_title">荣誉资质</div>
          <div class="honors_container">
            <!-- 第一行证书 honor1 -->
            <div class="honors_row">
              <img src="./assets/left.png" style="width: 40px;height: 40px;" @click="hp()" />
              <div class="honors_row" style="flex-direction: column;">
                <div class="honors_cards" style="overflow: auto;width: 1500px;align-items: center;">
                  <!-- qualificationsList -->
                  <div v-for="(item, index) in honor1List" :key="index">
                    <div class="honor_card">
                      <img :src="item.image" class="honor_image" :style="index == 2 ? 'width:330px;height:255px' : ''" />
                      <div class="honor_title">{{ item.title }}</div>
                    </div>
                  </div>
                </div>
              </div>
              <img src="./assets/right.png" style="width: 40px;height: 40px;" @click="hn()" />
            </div>
            <!-- 第二行证书 honor2-->
            <div class="honors_row">
              <img src="./assets/left.png" style="width: 40px;height: 40px;" @click="hpp()" />
              <div class="honors_row" style="flex-direction: column;">
                <div class="honors_cards" style="overflow: auto;width: 100%;align-items: center;">
                  <!-- qualificationsList -->
                  <div v-for="(item, index) in honor2List" :key="index">
                    <div class="honor_card">
                      <img :src="item.image" class="honor_image" style="width: 240px;height: 340px;"
                        :style="index == 2 ? 'width:330px;height:467px' : ''" />
                      <div class="honor_title">{{ item.title }}</div>
                    </div>
                  </div>
                </div>
              </div>
              <img src="./assets/right.png" style="width: 40px;height: 40px;" @click="hnn()" />
            </div>
          </div>
        </div>
      </div>
    </div>



    <div class="report" v-if="topIndex == 3 && newsId != null">
      <div class="report_container">
        <!-- 面包屑导航 -->
        <div class="breadcrumb">
          <span class="breadcrumb_item" @click="handleClick(0)">首页</span>
          <span class="breadcrumb_separator">></span>
          <span class="breadcrumb_item" @click="handleClick(3)">新闻资讯</span>
          <span class="breadcrumb_separator">></span>
          <span class="breadcrumb_item breadcrumb_active">资讯详情</span>
        </div>

        <!-- 文章标题和日期 -->
        <div class="article_header">
          <h1 class="article_title">{{ newDetail.title }}</h1>
          <div class="article_date">发布时间:{{ newDetail.published_at }}</div>
        </div>

        <!-- 横幅图片 -->
        <div class="article_banner">
          <img class="banner_image" :src="newDetail.main_image" />
        </div>

        <!-- 文章正文 -->
        <div class="article_content">
          <div>{{ contentHtml(newDetail.content) }}</div>
        </div>

        <!-- 底部导航 -->
        <div class="article_navigation">
          <div class="nav_prev" v-if="newDetail.previous_news == null">
            <div class="nav_label">上一篇</div>
            <div class="nav_title">无</div>
          </div>
          <div class="nav_prev" v-else @click="lookNews(newDetail.previous_news).id">
            <div class="nav_label">上一篇</div>
            <div class="nav_title">{{ newDetail.previous_news.title }}</div>
          </div>
          <div class="nav_prev" v-if="newDetail.next_news == null">
            <div class="nav_label">下一篇</div>
            <div class="nav_title">无</div>
          </div>
          <div class="nav_next" v-else @click="lookNews(newDetail.next_news).id">
            <div class="nav_label">下一篇</div>
            <div class="nav_title">{{ newDetail.next_news.title }}</div>
          </div>
        </div>
      </div>
    </div>


    <div class="good_detial" v-if="whichProduct != null">
      <div class="good_detial_container">
        <!-- 面包屑导航 -->
        <div class="breadcrumb">
          <span class="breadcrumb_item" @click="handleClick(0)">首页</span>
          <span class="breadcrumb_separator">></span>
          <span class="breadcrumb_item" @click="handleClick(2)">产品中心</span>
          <span class="breadcrumb_separator">></span>
          <span class="breadcrumb_item breadcrumb_active">产品详情</span>
        </div>

        <!-- 产品概览区域 -->
        <div class="product_overview">
          <!-- 左侧产品图片画廊 -->
          <div class="product_gallery">
            <div class="thumbnail_list">
              <div :class="selectedProductIndex === index ? 'thumbnail_item active' : 'thumbnail_item'"
                v-for="(image, index) in whichProduct.images" :key="index" @click="selectMainImage(index)">
                <img :src="image" class="thumbnail_image" />
              </div>
            </div>
            <div class="main_image_container">
              <img :src="whichProduct.images[selectedProductIndex]" class="main_image" />
            </div>
          </div>

          <!-- 右侧产品信息 -->
          <div class="product_info">
            <h1 class="product_title">{{ whichProduct.name }}</h1>
            <div class="product_description">{{ contentHtml(whichProduct.details) }}</div>
            <div class="product_description">规格：{{ whichProduct.guige }}</div>
            <div class="product_description">备案号：{{ whichProduct.record_number }}</div>
            <img src="./assets/send.png" style="width: 172px;height: 48px;margin-top: 80px;" @click="showConfirm()" />
          </div>
        </div>
        <img :src="whichProduct.introduction_image" style="width: 1400px;margin-top: 20px;object-fit: contain;" />
        <img :src="whichProduct.ingredients_image" style="width: 1400px;margin-top: 20px;object-fit: contain;" />

      </div>
    </div>

    <div class="contact" v-if="topIndex == 0 || topIndex == 4">
      <div class="contact_container">
        <div class="contact_title">联系我们</div>
        <div class="contact_left">
          <img class="contact_left_bg" src="./assets/bgz.png" v-if="topIndex == 0" />
          <div class="contact_info" v-if="topIndex == 4" style="font-size: 20px;font-weight: 600;"
            :style="topIndex == 4 ? 'margin-left: 0px;' : ''">{{ contactInfo.company_name }}</div>
          <div class="contact_info" :style="topIndex == 4 ? 'margin-left: 0px;' : ''">企业地址： {{ contactInfo.address }}
          </div>
          <div class="contact_info" :style="topIndex == 4 ? 'margin-left: 0px;' : ''">健康热线： {{
            contactInfo.phone_numbers[0] }} {{ contactInfo.phone_numbers[1] }} </div>
        </div>
        <mapM :postion="mapConfigs" class="contact_img" :style="topIndex == 4 ? 'width: 864px;height: 400px;' : ''">
        </mapM>
      </div>
      <div v-if="topIndex == 4" style="width: 1200px;position: relative;margin: 0px auto;height: 100px;">
        <div class="contact_code" v-if="topIndex == 4">
          <div class="contact_code_title">关注我们</div>
          <img class="contact_code_qr_code" :src="contactInfo.wechat_qr_code" alt="微信公众号" />
        </div>
      </div>
    </div>

    <div class="bottom">
      <div class="bottom_container">
        <div class="bottom_section">
          <div class="bottom_title" @click="handleClick(1)">关于我们</div>
          <div class="bottom_links">
            <div class="bottom_link">公司简介</div>
            <div class="bottom_link">企业文化</div>
            <div class="bottom_link">团队介绍</div>
            <div class="bottom_link">荣誉资质</div>
          </div>
        </div>
        <div class="bottom_section">
          <div class="bottom_title" @click="handleClick(2)">产品研究</div>
          <div class="bottom_links">
            <div class="bottom_link">科学创新</div>
            <div class="bottom_link">治疗领域</div>
            <div class="bottom_link">产品特性</div>
            <div class="bottom_link">产品管线</div>
            <div class="bottom_link">合作共赢</div>
          </div>
        </div>
        <div class="bottom_section">
          <div class="bottom_title" @click="handleClick(3)">新闻资讯</div>
          <div class="bottom_links">
            <div class="bottom_link">公司新闻</div>
            <div class="bottom_link">行业动态</div>
          </div>
        </div>
        <div class="bottom_section">
          <div class="bottom_title" @click="handleClick(4)">联系我们</div>
          <div class="bottom_contact_info">
            <div class="contact_line">
              <span class="contact_label">地址:</span>
              <span class="contact_text">{{ contactInfo.address }}</span>
            </div>
            <div class="contact_line">
              <span class="contact_label">健康热线:</span>
              <span class="contact_text">{{ contactInfo.phone_numbers[0] }} {{ contactInfo.phone_numbers[1] }}</span>
            </div>
            <div class="contact_line">
              <span class="contact_label">版权所有:</span>
              <span class="contact_text">{{ contactInfo.company_name }}</span>
            </div>
          </div>
        </div>
        <div class="bottom_section">
          <div class="bottom_title">关注我们</div>
          <div class="qr_code_container">
            <img class="qr_code" :src="contactInfo.wechat_qr_code" alt="微信公众号" />
            <div class="qr_code_text">微信公众号</div>
          </div>
        </div>
      </div>
    </div>


  </div>
</template>

<script>
import { getpeople, bannersList, aboutUs, segments, qualifications, newsList, newDetail, contactInfo, productCategories, productsByCategory, mapConfig, productDetail, searchProducts, getQualifications, getQualificationDetail } from '../request/api'

import mapM from './components/mapM.vue'

export default {
  components: {
    mapM
  },
  data() {
    return {
      honor1: 0,
      honor2: 0,
      honor1List: [],
      honor2List: [],

      ifSearch: false,

      topIndex: 0,
      newsId: null,//新闻索引
      //产品特性的区分
      whichSpac: 1,

      bannersList: [],
      //数据请求，关于我们
      aboutUs: {},
      //核心业务板块列表
      segmentsList: [],
      //荣誉资质列表
      qualificationsList: [],
      inQualification: 0,
      quaPage: 5,

      //新闻列表
      newsList: [],
      //新闻详情
      newDetail: {},
      //联系我们
      contactInfo: {},
      //地图配置
      mapConfigs: {},
      //产品分类列表
      categories: [],
      //产品分类列表索引
      categoriesIndex: 0,
      //当前选择的产品分类的产品列表
      products: [],
      //当前选择的产品分类的产品列表分页
      page: 5,
      productsCurrentPage: 1, // 当前页
      productsPerPageCount: null, // 总页数

      //当前选择的新闻分类的产品列表分页
      newsCurrentPage: 1, // 当前页
      newsPerPageCount: null, // 总页数
      //搜索文字
      searchText: '',

      //当前选择的产品的图片列表

      //核心业务板块鼠标悬浮
      onSegmentsIndex: 0,
      //哪个产品详情
      whichProduct: null,
      //是否展示产品展示
      ifShowProduct: true,


      selectList: ['首页', '关于我们', '产品中心', '新闻资讯', '联系我们'],
      imgList: ['', '', ''],
      activeCategory: 0,
      selectedProduct: 1,
      productImages: [
        './assets/Rectangle 34625731.png',
        './assets/Rectangle 34625731(1).png',
        './assets/Rectangle 34625735(1).png',
        './assets/Rectangle 34625738.png'
      ],
      mainImage: './assets/Rectangle 34625731.png',
      selectedProductIndex: 0,
      swiperSlides: [
        {
          title: '传承岐黄精华 承启本草新章',
          subtitle: '立志成为中医药产业科技创新发展的龙头企业，引领行业潮流',
          description: 'SCIENTIFIC AND TECHNOLOGICAL INNOVATION AND DEVELOPMENT OF THE TRADITIONAL CHINESE MEDICINE INDUSTRY',
          image: './assets/Rectangle 34625712.png'
        },
        {
          title: '终南圣草 品质传承',
          subtitle: '优选道地药材，古法培制工艺，从原料到生产严格把控',
          description: '确保消费者放心使用，为人类健康带来福祉',
          image: './assets/Rectangle 34625721.png'
        },
        {
          title: '诚信为本 创新发展',
          subtitle: '始终坚守诚实守信的原则，从产品质量到服务承诺',
          description: '不断探索中医药发展的新路径，以满足市场的不断变化和消费者日益增长的需求',
          image: './assets/Rectangle 34625722.png'
        },
        {
          title: '品牌强国 优选工程',
          subtitle: '成功入选大健康行业品牌强国优选工程成员单位',
          description: '构建专业、全国性、国际化的自主品牌推广平台，发挥品牌引领作用',
          image: './assets/Rectangle 34625735.png'
        }
      ],
      currentSlide: 0,
      peoplee: []
    }
  },
  computed: {
    currentProducts() {
      return this.products;
    }
  },
  created() {
    this.getMapConfig();
    this.getBannersList();
    this.getAboutUs();
    this.getSegments();
    this.getQualifications();
    this.gerContactInfo();
    this.gerProductCategories();
    this.getpeopl()
    let data = {
      page: 1,
      limit: 6
    }
    this.getNewsList(data);
  },
  async mounted() {
    this.startAutoPlay();

    // await this.fetchLocation();
    this.$nextTick(() => {
      this.getMapConfig(); // 确保数据和DOM都就绪
    });
  },
  // mounted() {
  // },
  beforeUnmount() {
    this.stopAutoPlay();
  },
  methods: {
    getpeopl() {
      getpeople().then(res => {
        console.log(res)
        this.peoplee = res.data
      })
    },

    hp() {
      const firstElement = this.honor1List.shift();
      this.honor1List.push(firstElement);
    },
    hn() {
      const lastItem = this.honor1List.pop();  // 移除最后一个元素 → 5
      this.honor1List.unshift(lastItem);      // 添加到数组开头 → [5,1,2,3,4]
    },
    hpp() {
      const firstElement = this.honor2List.shift();
      this.honor2List.push(firstElement);
    },
    hnn() {
      const lastItem = this.honor2List.pop();  // 移除最后一个元素 → 5
      this.honor2List.unshift(lastItem);      // 添加到数组开头 → [5,1,2,3,4]
    },




    showConfirm() {
      alert('您可以拨打电话：' + this.contactInfo.phone_numbers[0] + ' ' + this.contactInfo.phone_numbers[1] + ' 进行咨询')
    },
    //获取关于我们
    getBannersList() {
      console.log();
      bannersList().then(res => {
        this.bannersList = res.data
      })
    },
    //获取关于我们
    getAboutUs() {
      console.log();
      aboutUs().then(res => {
        this.aboutUs = res.data
      })
    },
    //获取核心业务板块列表
    getSegments() {
      segments().then(res => {
        this.segmentsList = res.data
      })
    },
    //获取荣誉资质列表
    getQualifications() {
      qualifications().then(res => {
        this.qualificationsList = res.data
        this.honor1List = this.qualificationsList.filter(it => it.category == 1)
        this.honor2List = this.qualificationsList.filter(it => it.category == 2)
      })
    },
    //获取新闻列表
    getNewsList(data) {
      newsList(data).then(res => {
        this.newsList = res.data.list
        this.newsPerPageCount = res.data.total_pages
        console.log(res)
      })
    },
    //获取新闻详情
    getNewDetail() {
      let data = {
        news_id: this.newsId
      }
      newDetail(data).then(res => {
        this.newDetail = res.data
      })
    },
    //获取联系我们信息
    gerContactInfo() {
      contactInfo().then(res => {
        this.contactInfo = res.data
      })
    },
    //获取地图配置
    getMapConfig() {
      mapConfig().then(res => {
        console.log(res)
        this.mapConfigs = res.data
      })
    },
    //获取产品分类列表
    gerProductCategories() {
      productCategories().then(res => {
        this.categories = res.data
        this.getProductsByCategory();
      })
    },
    //获取产品列表
    getProductsByCategory() {
      let data = {
        category_id: this.categories[this.categoriesIndex].id,
        page: this.productsCurrentPage,
        limit: 16
      }
      productsByCategory(data).then(res => {

        this.productsPerPageCount = res.data.last_page
        this.products = res.data.data
        console.log(res)
      })
    },
    projectsPrevPage() {
      if (this.productsCurrentPage > 1) {
        if (this.page == this.productsCurrentPage + 4) {
          this.page--
        }
        this.productsCurrentPage--;
        let data = {
          keyword: this.searchText,
          page: this.productsCurrentPage,
          limit: 16
        }
        if (data.keyword == '') {
          this.getProductsByCategory();
          return
        }
        this.searchProduct(data)

      }
    },
    projectsNextPage() {
      if (this.productsCurrentPage < this.productsPerPageCount) {
        if (this.page == this.productsCurrentPage) {
          this.page++
        }
        this.productsCurrentPage++;
        let data = {
          keyword: this.searchText,
          page: this.productsCurrentPage,
          limit: 16
        }
        if (data.keyword == '') {
          this.getProductsByCategory();
          return
        }
        this.searchProduct(data)
      }
    },
    newsPrevPage() {
      if (this.newsCurrentPage > 1) {
        if (this.page == this.newsCurrentPage + 4) {
          this.page--
        }
        this.newsCurrentPage--;
        this.getNewsList({
          page: this.newsCurrentPage,
          limit: 6
        })
      }
    },
    newsNextPage() {
      if (this.newsCurrentPage < this.newsPerPageCount) {
        if (this.page == this.newsCurrentPage) {
          this.page++
        }
        this.newsCurrentPage++;
        this.getNewsList({
          page: this.newsCurrentPage,
          limit: 6
        })
      }
    },

    //鼠标悬浮？
    onSegments(index) {
      this.onSegmentsIndex = index
    },



    //选择新闻
    lookNews(item) {
      this.topIndex = 3
      this.newsId = item.id;
      this.getNewDetail()
    },
    //选择头部内容
    handleClick(index) {
      const scrollToTop = () => {
        const c = document.documentElement.scrollTop || document.body.scrollTop;
        if (c > 15) {
          console.log(c);
          window.requestAnimationFrame(scrollToTop);
          window.scrollTo(0, c - c / 8);
        }
      };
      scrollToTop();
      this.ifSearch = false
      this.topIndex = index
      this.whichProduct = null
      this.newsId = null
      this.ifShowProduct = true
      this.searchText = ''
      this.categoriesIndex = 0
      this.page = 5
      //当前选择的产品分类的产品列表分页
      this.productsCurrentPage = 1 // 当前页

      //当前选择的新闻分类的产品列表分页
      this.newsCurrentPage = 1 // 当前页
      let data = {
        page: 1,
        limit: 6
      }
      this.getNewsList(data);
      this.getProductsByCategory();
    },
    //选择产品分类
    selectCategory(index) {
      this.searchText = ''
      this.categoriesIndex = index;
      this.getProductsByCategory();
    },
    //上一个分类产品
    prevProduct() {
      if (this.categoriesIndex > 0) {
        this.categoriesIndex--;
        this.getProductsByCategory(this.categoriesIndex);
      }

    },
    //下一个分类
    nextProduct() {
      if (this.categoriesIndex < this.categories.length - 1) {
        this.categoriesIndex++;
        this.getProductsByCategory(this.categoriesIndex);
      }
    },

    //监听输入
    handleInput() {
      if (this.timeoutId) {
        clearTimeout(this.timeoutId)
      }

      this.timeoutId = setTimeout(() => {
        console.log(this.searchText)
        this.serach()
      }, 1000)
    },
    //调用搜索
    serach() {
      this.newsCurrentPage = 1// 当前页
      this.productsCurrentPage = 1// 当前页
      let data = {
        page: 1,
        keyword: this.searchText
      }
      if (data.keyword == '') {
        return
      }
      if (this.topIndex == 2) {
        data.limit = 16
        data.category_id = this.categories[this.categoriesIndex].id
        this.searchProduct(data)
      } else {
        data.limit = 6
        this.getNewsList(data)
      }
    },
    //搜索商品
    searchProduct(data) {
      searchProducts(data).then((res) => {
        console.log(res)
        this.productsPerPageCount = res.data.last_page
        console.log(res)
        let arr = []
        if (res.data.data.length == 0) {
          this.products = []
        }
        for (let i = 0; i < res.data.data.length; i++) {
          if (res.data.data[i].category_id == this.categories[this.categoriesIndex].id) {
            this.products = [...res.data.data[i].products]
            return
            // arr.push(res.data.data[i])
          } else {
            this.products = []

          }
        }
        // this.products=arr
      })
    },


    //富文本只要字
    contentHtml(content) {
      // 富文本编辑器的内容如何只获得文字去掉标签
      // content = content.replace(/<[^>]+>/g, "");
      // 在上面的基础上还去掉了换行<br/>
      if(!content){
        return '暂无详情'
      }
      content = content.replace(/<[^>]+>/g, "").replace(/(\n)/g, "");
      content = content.replace(/&nbsp;|&ldquo;|&rdquo;/g, ''); // 新增
      return content;
      // 请注意，我这个是自定义全局方法，用于超过字数显示省略号的...
      // 之前文章有写过，下面也放上了链接，自行查看
    },


    //选择产品
    selectProduct(item) {
      const scrollToTop = () => {
        const c = document.documentElement.scrollTop || document.body.scrollTop;
        if (c > 15) {
          console.log(c);
          window.requestAnimationFrame(scrollToTop);
          window.scrollTo(0, c - c / 8);
        }
      };
      scrollToTop();

      this.whichProduct = item;
      this.topIndex = 2
      this.ifShowProduct = false;
    },
    //上一个荣誉资质
    prevHonors() {
      console.log(this.inQualification)
      console.log(this.quaPage)

      if (this.inQualification == 0) {
        return
      }
      if (this.quaPage - 4 == this.inQualification) {
        this.quaPage--
      }
      this.inQualification--;
      console.log(this.inQualification)
      console.log(this.quaPage)
    },
    //下一个荣誉资质
    nextHonors() {
      console.log(this.inQualification)
      console.log(this.quaPage)
      if (this.inQualification == this.qualificationsList.length - 1) {
        return
      }
      if (this.qualificationsList.length > 5 && this.inQualification < this.qualificationsList.length - 1) {
        this.quaPage++
      }
      this.inQualification++;
      console.log(this.inQualification)
      console.log(this.quaPage)
    },
    selectMainImage(index) {
      this.selectedProductIndex = index;
    },
    goToSlide(index) {
      this.currentSlide = index;
    },
    startAutoPlay() {
      this.autoPlayInterval = setInterval(() => {
        this.currentSlide = (this.currentSlide + 1) % this.bannersList.length;
      }, 5000);
    },
    stopAutoPlay() {
      if (this.autoPlayInterval) {
        clearInterval(this.autoPlayInterval);
      }
    }
  }
}
</script>
<style scoped>
.box {
  width: 100%;
  background-image: white;
}

.top {
  position: absolute;
  z-index: 999;
  top: 16px;
  left: 50%;
  transform: translate(-50%, 0);
  width: 96%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.top_left {
  display: flex;
  align-items: center;
}

.logo {
  width: 60px;
  height: 60px;
  margin-right: 16px;
}

.font {
  width: 124px;
  height: 34px;
}

.top_right {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.top_right_item {
  font-family: Source Han Sans SC, Source Han Sans SC;
  font-weight: 500;
  font-size: 18px;
  color: #555555;
  margin-right: 76px;
}

.search_box {
  display: flex;
}

.select_in {
  font-weight: 600;
  font-size: 20px;
  color: #000504;
}

.search {
  width: 20px;
  height: 20px;
  margin-right: 10px;
}

.swiper {
  width: 100%;
  height: 900px;
  position: relative;
  overflow: hidden;
}

.swiper_container {
  width: 100%;
  height: 100%;
  position: relative;
}

.swiper_slide {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  opacity: 0;
  transition: opacity 0.8s ease-in-out;
}

.swiper_slide.active {
  opacity: 1;
}

.slide_background {
  width: 100%;
  height: 100%;
  position: relative;
}

.slide_image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.slide_overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(135deg, rgba(0, 0, 0, 0.4) 0%, rgba(0, 0, 0, 0.2) 50%, rgba(0, 0, 0, 0.6) 100%);
}

.slide_content {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  color: #fff;
  max-width: 800px;
  padding: 0 20px;
  z-index: 10;
}

.slide_title {
  font-size: 48px;
  font-weight: bold;
  margin-bottom: 20px;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.7);
  line-height: 1.2;
}

.slide_subtitle {
  font-size: 24px;
  margin-bottom: 30px;
  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.7);
  line-height: 1.4;
}

.slide_description {
  font-size: 18px;
  line-height: 1.8;
  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.7);
  opacity: 0.9;
}

.swiper_pagination {
  position: absolute;
  bottom: 40px;
  left: 0;
  width: 100%;
  display: flex;
  justify-content: center;
  gap: 12px;
  z-index: 20;
}

.pagination_dot {
  width: 40px;
  height: 6px;
  background: rgba(255, 255, 255, 0.5);
  border: 1px solid rgba(255, 255, 255, 0.8);
  border-radius: 3px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.pagination_dot:hover {
  background: rgba(255, 255, 255, 0.8);
  transform: scale(1.05);
}

.pagination_dot.active {
  background: #fff;
  border-color: #fff;
  box-shadow: 0 0 8px rgba(255, 255, 255, 0.5);
}

.bg_img {
  width: 100%;
  height: 700px;
}

.about {
  padding: 80px 0;
  background: #fff;
}

.about_top {
  position: relative;
  width: 1400px;
  margin: 0 auto;
  display: flex;
  gap: 60px;
  align-items: center;
  padding: 0 20px;
  margin-bottom: 80px;
}

.about_left {
  flex: 1;
}

.about_building {
  width: 642px;
  height: 380px;
  object-fit: cover;
  border-radius: 8px;
}

.about_right {
  flex: 1;
  padding: 20px 0;
}

.about_title {
  font-family: Source Han Sans SC, Source Han Sans SC;
  font-weight: bold;
  font-size: 28px;
  color: #222222;
  margin-bottom: 12px;
}

.about_subtitle {
  font-family: Source Han Sans SC, Source Han Sans SC;
  font-weight: 500;
  font-size: 18px;
  color: #333333;
}

.about_line {
  width: 711px;
  height: 0px;
  border: 4px solid #3D6451;
  opacity: 0.4;
  margin: 30px 0px;
  border-radius: 20px;
}

.about_content {
  margin-bottom: 32px;
}

.about_content p {
  font-size: 16px;
  line-height: 1.8;
  color: #555;
  margin-bottom: 16px;
}

.about_more1 {
  position: absolute;
  right: 0;
  bottom: 0;
  z-index: 999;
  width: 114px;
  height: 32px;
}

.about_more {
  position: absolute;
  right: 50%;
  transform: translate(50%, 0);
  bottom: 20px;
  z-index: 999;
  width: 114px;
  height: 32px;
}

.arrow {
  width: 16px;
  height: 16px;
}

.about_bottom {
  width: 1400px;
  margin: 0 auto;
  padding: 0 20px;
}

.about_bottom_title {
  text-align: center;
  margin-bottom: 40px;
  font-family: Source Han Sans SC, Source Han Sans SC;
  font-weight: bold;
  font-size: 28px;
  color: #222222;
}

.business_cards {
  display: flex;
  overflow: auto;
  gap: 24px;
}

.business_card {
  position: relative;
  text-align: center;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease;
  width: 249px;
  height: 475px;
  border-radius: 20px;
}

.business_card:hover {
  width: 364px;
  transform: translateY(-8px);
}

.card_image {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  object-fit: contain;
}

.business_card_content {
  position: absolute;
  bottom: 0px;
  left: 50%;
  transform: translate(-50%, 0);
  z-index: 999;
  width: 100%;
  height: 260px;
  object-fit: cover;
}

.card_title {
  font-family: Source Han Sans SC, Source Han Sans SC;
  font-weight: 500;
  font-size: 18px;
  color: #FFFFFF;
}

.card_text {
  box-sizing: border-box;
  padding: 12px;
  text-align: left;
  font-family: Source Han Sans SC, Source Han Sans SC;
  font-weight: 400;
  font-size: 14px;
  color: #FFFFFF;
}

.about_more {
  width: 114px;
  height: 32px;
}

.card_more_btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  margin-bottom: 16px;
  border: 2px dashed #333;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.card_more_btn:hover {
  background: #f5f5f5;
}

.card_more_btn span {
  font-size: 14px;
  color: #333;
}

.people {
  display: flex;
  align-items: end;
  flex-direction: column;
  padding: 80px 0;
  background: #f5f5f5;
}

.people_container {
  width: 1200px;
  margin: 0 auto 20px;
  display: flex;
  gap: 60px;
  align-items: flex-start;
  padding: 0 20px;
}

.expert_photo_frame {
  width: 368px;
  height: 460px;
  border-radius: 8px;
}

.expert_photo {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 4px;
}

.people_right {
  flex: 1;
}

.expert_title {
  font-family: Source Han Sans SC, Source Han Sans SC;
  font-weight: bold;
  font-size: 28px;
  color: #222222;
  margin-bottom: 60px;
}

.expert_name {
  font-family: Source Han Sans SC, Source Han Sans SC;
  font-weight: bold;
  font-size: 22px;
  color: #222222;
  margin-bottom: 20px;
}

.expert_intro {
  font-size: 16px;
  line-height: 1.8;
  color: #333;
  margin-bottom: 24px;
}

.expert_separator {
  width: 100%;
  height: 1px;
  background: #ddd;
  margin: 24px 0;
}

.expert_details {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.detail_section {
  display: flex;
  border-radius: 6px;
  margin-bottom: 10px;
}

.detail_title {
  flex-shrink: 0;
  width: 80px;
  font-family: Source Han Sans SC, Source Han Sans SC;
  font-weight: bold;
  font-size: 16px;
  color: #333333;
  margin-right: 22px;
}

.detail_content {
  font-family: Source Han Sans SC, Source Han Sans SC;
  font-weight: 500;
  font-size: 14px;
  color: #3A3A3A;
}

.goods {
  padding: 80px 0;
  background: #fff;
}

.goods_container {
  width: 1400px;
  margin: 0 auto;
  padding: 0 20px;
}

.goods_title {
  text-align: center;
  font-size: 36px;
  font-weight: bold;
  color: #000;
  margin-bottom: 40px;
}

.category_tabs {
  display: flex;
  justify-content: center;
  gap: 40px;
  margin-bottom: 60px;
}

.category_tab {
  font-size: 18px;
  color: #333;
  cursor: pointer;
  padding: 8px 0;
  transition: all 0.3s ease;
  position: relative;
}

.category_tab_active {
  font-size: 18px;
  font-weight: 600;
  cursor: pointer;
  padding: 8px 0;
  position: relative;
  color: #222222;
}

.category_tab_active::after {
  content: '';
  position: absolute;
  bottom: -4px;
  left: 0;
  width: 100%;
  height: 2px;
  background: #000;

  width: 72px;
  height: 4px;
  background: #222222;
  border-radius: 999px 999px 999px 999px;
}

.products_section {
  position: relative;
  display: flex;
  align-items: center;
  gap: 20px;
}

.left_img {
  width: 44px;
  height: 44px;
}

.goods_pages {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 480px;
  margin: 60px auto;
}

.nav_arrow {
  width: 40px;
  height: 40px;
  border: 2px dashed #ccc;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s ease;
  background: #fff;
}

.nav_arrow:hover {
  background: #f5f5f5;
  border-color: #999;
}

.nav_arrow span {
  font-size: 18px;
  color: #333;
  font-weight: bold;
}

.products_container {
  flex: 1;
  display: flex;
  gap: 24px;
  overflow: hidden;
}

.product_card {
  padding: 4px;
  background: #fff;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  cursor: pointer;
  transition: all 0.3s ease;
}

.product_card:hover {
  box-shadow: 0 2px 8px #3D6451;

  border: #3D6451 1px solid;
  color: #3D6451;
}

.product_card_selected {
  flex: 1;
  background: #fff;
  border: 2px dashed #333;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  cursor: pointer;
  transition: all 0.3s ease;
  min-width: 250px;
}

.product_image_container {
  position: relative;
  width: 100%;
  height: 300px;
  overflow: hidden;
}

.product_image {
  border-radius: 8px;
  width: 100%;
  height: 300px;
  object-fit: cover;
}

.product_overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(135deg, rgba(0, 0, 0, 0.3) 0%, rgba(0, 0, 0, 0.1) 100%);
  padding: 16px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.product_type {
  color: #fff;
  font-size: 18px;
  font-weight: bold;
  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.5);
}

.product_tags {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.product_tag {
  background: #4CAF50;
  color: #fff;
  padding: 4px 8px;
  border-radius: 12px;
  font-size: 12px;
  align-self: flex-start;
}

.product_info {
  padding: 16px;
}

.product_name {
  font-size: 16px;
  font-weight: bold;
  color: #000;
  margin-top: 16px;
  margin-bottom: 8px;
}

.product_name:hover {
  color: #3D6451;
}

.product_des {
  width: 288px;
  height: 38px;
  font-family: Source Han Sans SC, Source Han Sans SC;
  font-weight: 400;
  font-size: 14px;
  color: #3A3A3A;

  overflow: hidden;
  /* 隐藏溢出 */
  word-break: break-all;
  /* break-all(允许在单词内换行。) */
  text-overflow: ellipsis;
  /* 超出部分省略号 */
  display: -webkit-box;
  /** 对象作为伸缩盒子模型显示 **/
  -webkit-box-orient: vertical;
  /** 设置或检索伸缩盒对象的子元素的排列方式 **/
  -webkit-line-clamp: 2;
  /** 显示的行数 **/
}

.product_des:hover {
  color: #3D6451;
}

.news {
  padding: 80px 0;
  background: #f5f5f5;
}

.news_container {
  margin: 0px auto;
  width: 1400px;
  margin: 0 auto;
  padding: 0 20px;
}

.news_title {
  text-align: center;
  margin-bottom: 40px;
  font-family: Source Han Sans SC, Source Han Sans SC;
  font-weight: bold;
  font-size: 28px;
  color: #222222;
}

.news_cards {
  width: 100%;
  display: flex;
  gap: 24px;
  align-items: center;
  justify-content: start;
}

.news_card {
  background: #fff;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease;
  display: flex;
  flex-direction: column;
  width: 440px;
  height: 420px;
}

.news_card:hover {
  transform: translateY(-8px);
}

.news_image_container {
  width: 440px;
  height: 262px;
}

.news_image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.news_content {
  padding: 16px;
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.news_article_title {
  font-size: 18px;
  font-weight: bold;
  color: #333;
  margin-bottom: 8px;
}

.news_article_description {
  font-size: 14px;
  color: #666;
  line-height: 1.6;
  margin-bottom: 12px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.news_article_date {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 12px;
  color: #999;
  margin-bottom: 16px;
}

.news_look {
  display: flex;
  align-items: center;
}

.news_look_icon {
  width: 22px;
  height: 22px;
}

.news_view_btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  border: 2px dashed #333;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.news_view_btn:hover {
  background: #f5f5f5;
}

.news_view_btn span {
  font-size: 14px;
  color: #333;
}

.news_more_btn {
  text-align: center;
  margin-top: 60px;
}

.news_more {
  width: 114px;
  height: 32px;
}

.contact {
  position: relative;
  padding: 80px 0;
  background: #fff;
  height: 500px;
}

.contact_container {
  position: relative;
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  gap: 60px;
}

.contact_left {
  position: relative;
  z-index: 999;
  display: flex;
  justify-content: center;
  flex-direction: column;
  width: 692px;
  height: 206px;
  flex-shrink: 0;
  border-radius: 8px;
}

.contact_left_bg {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: -1;
}

.contact_info {
  margin-left: 40px;
  font-family: Source Han Sans SC, Source Han Sans SC;
  font-weight: 500;
  font-size: 16px;
  color: #3A3A3A;
  margin-bottom: 16px;
}

.contact_img {
  width: 774px;
  height: 376px;
  margin-left: -130px;
}

.contact_code {
  position: absolute;
  left: 0;
  bottom: 0;
  z-index: 99;
}

.contact_code_title {
  font-family: Source Han Sans SC, Source Han Sans SC;
  font-weight: 500;
  font-size: 16px;
  margin-bottom: 16px;
}

.contact_code_qr_code {
  width: 150px;
  height: 150px;
}

.contact_title {
  position: absolute;
  top: 0;
  left: 0;
  font-family: Source Han Sans SC, Source Han Sans SC;
  font-weight: bold;
  font-size: 28px;
  color: #222222;
}

.contact_info_box {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.contact_info_item {
  display: flex;
  align-items: center;
  gap: 10px;
}

.contact_label {
  font-size: 18px;
  font-weight: 600;
  color: #333;
}

.contact_value {
  font-size: 16px;
  color: #666;
  line-height: 1.8;
}

.contact_right {
  flex: 1;
}

.map_container {
  width: 100%;
  height: 400px;
  background: #f0f0f0;
  border-radius: 8px;
  overflow: hidden;
  position: relative;
}

.map_placeholder {
  width: 100%;
  height: 100%;
  background: linear-gradient(135deg, #e0e0e0 0%, #f5f5f5 100%);
  position: relative;
}

.map_content {
  width: 100%;
  height: 100%;
  position: relative;
  padding: 20px;
}

.map_header {
  position: absolute;
  top: 10px;
  left: 10px;
  z-index: 10;
}

.map_logo {
  background: #fff;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
  color: #333;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.map_body {
  width: 100%;
  height: 100%;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}

.map_location_pin {
  width: 20px;
  height: 30px;
  background: #007AFF;
  border-radius: 50% 50% 50% 0;
  transform: rotate(-45deg);
  position: relative;
  margin-bottom: 40px;
}

.map_location_pin::after {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%) rotate(45deg);
  width: 8px;
  height: 8px;
  background: #fff;
  border-radius: 50%;
}

.map_info_popup {
  position: absolute;
  bottom: 60px;
  left: 50%;
  transform: translateX(-50%);
  background: #fff;
  border-radius: 8px;
  padding: 16px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  min-width: 200px;
}

.popup_title {
  font-size: 16px;
  font-weight: bold;
  color: #000;
  margin-bottom: 8px;
}

.popup_address {
  font-size: 14px;
  color: #666;
  margin-bottom: 12px;
  line-height: 1.4;
}

.popup_actions {
  display: flex;
  gap: 8px;
  margin-bottom: 8px;
}

.popup_action {
  font-size: 12px;
  color: #007AFF;
  cursor: pointer;
  padding: 4px 8px;
  border-radius: 4px;
  background: #f0f8ff;
}

.popup_action:hover {
  background: #e0f0ff;
}

.popup_close {
  position: absolute;
  top: 8px;
  right: 8px;
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: #999;
  font-size: 16px;
}

.map_controls {
  position: absolute;
  right: 20px;
  top: 50%;
  transform: translateY(-50%);
}

.map_zoom_controls {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.zoom_btn {
  width: 32px;
  height: 32px;
  background: #fff;
  border: 1px solid #ddd;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: 16px;
  color: #333;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.zoom_btn:hover {
  background: #f5f5f5;
}

.map_footer {
  position: absolute;
  bottom: 10px;
  left: 10px;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.map_scale {
  font-size: 10px;
  color: #666;
}

.map_copyright {
  font-size: 10px;
  color: #999;
}

.bottom {
  background-color: #404c44;
  /* 深绿色背景 */
  padding: 80px 0;
  color: #fff;
  /* 文字颜色 */
}

.bottom_container {
  max-width: 1200px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  /* 5列布局 */
  gap: 40px;
  /* 列间距 */
  padding: 0 20px;
}

.bottom_section {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.bottom_title {
  font-family: Source Han Sans SC, Source Han Sans SC;
  font-weight: 600;
  font-size: 20px;
  color: #FFFFFF;
  margin-bottom: 16px;
}

.bottom_links {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.bottom_link {
  color: #fff;
  text-decoration: none;
  transition: opacity 0.3s ease;
  font-family: Source Han Sans SC, Source Han Sans SC;
  font-weight: 500;
  font-size: 14px;
}

.bottom_link:hover {
  opacity: 0.8;
}

.bottom_contact_info {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.contact_line {
  display: flex;
  align-items: center;
  gap: 10px;
}

.contact_label {
  flex-shrink: 0;
  font-family: Source Han Sans SC, Source Han Sans SC;
  font-weight: 500;
  font-size: 16px;
  color: #FFFFFF;
}

.contact_text {
  width: 572px;
  font-size: 16px;
  color: #fff;
  line-height: 1.8;
}

.qr_code_container {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
}

.qr_code {
  width: 120px;
  height: 120px;
  background: #fff;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.qr_code_placeholder {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f0f0f0;
  border-radius: 4px;
}

.qr_code_center_icon {
  width: 40px;
  height: 40px;
  background: #007AFF;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 24px;
}

.qr_code_text {
  font-size: 16px;
  font-weight: 500;
  color: #fff;
}

.properties {
  padding: 80px 0;
  background: #fff;
}

.properties_container {
  width: 1600px;
  margin: 0 auto;
  padding: 0 20px;
}

.features_section {
  margin: 0 auto;
  margin-bottom: 80px;
}

.features_title {
  font-size: 36px;
  font-weight: bold;
  color: #000;
  text-align: center;
  margin-bottom: 40px;
}

.features_cards {
  display: flex;
  justify-content: space-around;
  margin-bottom: 30px;
}

.feature_card {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  flex: 1;
}

.feature_icon {
  font-size: 40px;
  color: #007AFF;
}

.feature_icon_inheritance {
  font-size: 40px;
  color: #007AFF;
}

.feature_icon_safety {
  font-size: 40px;
  color: #007AFF;
}

.feature_icon_efficacy {
  font-size: 40px;
  color: #007AFF;
}

.feature_icon_nourishment {
  font-size: 40px;
  color: #007AFF;
}

.feature_icon_convenience {
  font-size: 40px;
  color: #007AFF;
}

.feature_label {
  font-size: 18px;
  font-weight: 600;
  color: #333;
  text-align: center;
}

.feature_connector {
  width: 1px;
  height: 40px;
  background: #ddd;
  margin: 0 20px;
}

.safety_description {
  text-align: center;
  font-size: 16px;
  color: #666;
  line-height: 1.8;
}

.honors_section {
  width: 1600px;
  margin-top: 80px;
}

.honors_title {
  font-size: 36px;
  font-weight: bold;
  color: #000;
  text-align: center;
  margin-bottom: 60px;
}

.honors_container {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.honors_row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 20px;
  font-family: Source Han Sans SC, Source Han Sans SC;
  font-weight: 600;
  font-size: 18px;
  color: #333333;
}

.nav_arrow {
  width: 40px;
  height: 40px;
  border: 2px dashed #ccc;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s ease;
  background: #fff;
}

.nav_arrow:hover {
  background: #f5f5f5;
  border-color: #999;
}

.nav_arrow span {
  font-size: 18px;
  color: #333;
  font-weight: bold;
}

.honors_cards {
  flex: 1;
  display: flex;
  justify-content: space-between;
  gap: 20px;
}

.honor_card {
  flex: 1;
  background: #fff;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 20px;
}

.honor_image {
  width: 240px;
  height: 165px;
}

.honor_card:hover {
  transform: translateY(-8px);
}

.honor_seal {
  font-size: 40px;
  color: #007AFF;
  margin-bottom: 10px;
}

.honor_title {
  font-size: 18px;
  font-weight: bold;
  color: #333;
  margin-bottom: 8px;
}

.honor_subtitle {
  font-size: 14px;
  color: #666;
  margin-bottom: 10px;
}

.honor_company {
  font-size: 14px;
  color: #666;
  margin-top: 10px;
}

.honor_card_highlighted {
  background: #f0f8ff;
  /* 浅蓝色背景 */
  border: 2px dashed #007AFF;
  /* 蓝色边框 */
}

.values {
  padding: 80px 0;
  background: #f5f5f5;
}

.values_container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.values_title {
  text-align: center;
  font-size: 36px;
  font-weight: bold;
  color: #000;
  margin-bottom: 60px;
}

.value_sections {
  display: flex;
  justify-content: space-around;
  gap: 40px;
}

.value_section {
  flex: 1;
  text-align: center;
  background: #fff;
  border-radius: 8px;
  padding: 30px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease;
}

.value_section:hover {
  transform: translateY(-8px);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
}

.value_icon_wrapper {
  position: relative;
  margin-bottom: 20px;
  display: flex;
  justify-content: center;
}

.value_icon {
  position: relative;
  width: 80px;
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: linear-gradient(135deg, #f0f8ff 0%, #e6f3ff 100%);
  border: 2px solid #007AFF;
}

.value_name {
  font-size: 24px;
  font-weight: bold;
  color: #000;
  margin-bottom: 16px;
}

.value_description {
  font-size: 16px;
  line-height: 1.8;
  color: #666;
  text-align: left;
}

.icon_shield {
  font-size: 40px;
  color: #007AFF;
  position: relative;
  z-index: 2;
}

.icon_stack {
  position: relative;
  width: 60px;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.stack_layer {
  position: absolute;
  width: 100%;
  height: 100%;
  border-radius: 50%;
  border: 2px dashed #007AFF;
  opacity: 0.3;
  animation: rotate 10s linear infinite;
}

.stack_layer_1 {
  animation-delay: -1s;
}

.stack_layer_2 {
  animation-delay: -2s;
}

.stack_layer_3 {
  animation-delay: -3s;
}

@keyframes rotate {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}

.stack_plus {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 24px;
  color: #007AFF;
  font-weight: bold;
  z-index: 2;
}

.icon_glow {
  position: absolute;
  top: -10px;
  left: -10px;
  width: calc(100% + 20px);
  height: calc(100% + 20px);
  border-radius: 50%;
  background: radial-gradient(circle, rgba(0, 122, 255, 0.2) 0%, transparent 70%);
  opacity: 0;
  transition: opacity 0.5s ease-in-out;
  pointer-events: none;
}

.value_section:hover .icon_glow {
  opacity: 1;
}

.icon_cube {
  position: relative;
  width: 60px;
  height: 60px;
  transform-style: preserve-3d;
  transform: rotateX(-30deg) rotateY(45deg);
  animation: cubeRotate 8s linear infinite;
}

@keyframes cubeRotate {
  0% {
    transform: rotateX(-30deg) rotateY(0deg);
  }

  100% {
    transform: rotateX(-30deg) rotateY(360deg);
  }
}

.cube_center {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 12px;
  height: 12px;
  background: #007AFF;
  border-radius: 50%;
  box-shadow: 0 0 10px rgba(0, 122, 255, 0.5);
}

.cube_satellite {
  position: absolute;
  width: 8px;
  height: 8px;
  background: #007AFF;
  border-radius: 50%;
  box-shadow: 0 0 5px rgba(0, 122, 255, 0.3);
  animation: satelliteFloat 3s ease-in-out infinite;
}

.cube_satellite_1 {
  top: 0;
  left: 0;
  animation-delay: 0s;
}

.cube_satellite_2 {
  top: 0;
  right: 0;
  animation-delay: 0.5s;
}

.cube_satellite_3 {
  bottom: 0;
  left: 0;
  animation-delay: 1s;
}

.cube_satellite_4 {
  bottom: 0;
  right: 0;
  animation-delay: 1.5s;
}

@keyframes satelliteFloat {

  0%,
  100% {
    transform: translateY(0px);
  }

  50% {
    transform: translateY(-5px);
  }
}

.report {
  padding: 80px 0;
  background: #fff;
}

.report_container {
  width: 1400px;
  margin: 0 auto;
  padding: 0 20px;
  border-radius: 8px;
}

.breadcrumb {
  font-size: 14px;
  color: #666;
  margin-bottom: 40px;
  display: flex;
  align-items: center;
  padding: 20px 0;
}

.breadcrumb_item {
  color: #333;
  cursor: pointer;
  transition: color 0.3s ease;
}

.breadcrumb_item:hover {}

.breadcrumb_separator {
  margin: 0 8px;
  color: #ccc;
}

.breadcrumb_active {
  font-weight: 600;
}

.article_header {
  text-align: center;
  margin-bottom: 40px;
  padding: 0 20px;
}

.article_title {
  margin-bottom: 16px;
  text-align: left;
  font-family: Source Han Sans SC, Source Han Sans SC;
  font-weight: bold;
  font-size: 28px;
  color: #333333;
}

.article_date {
  text-align: left;

  font-size: 14px;
  color: #999;
  font-weight: 500;
}

.article_banner {
  position: relative;
  width: 100%;
  border-radius: 8px;
  margin-bottom: 40px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.banner_image {
  width: 100%;
  object-fit: cover;
  /* height: 1000px; */
  object-fit: cover;
  transition: transform 0.3s ease;
}

.article_banner:hover .banner_image {
  transform: scale(1.05);
}

.banner_overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(to bottom, rgba(0, 0, 0, 0.4) 0%, rgba(0, 0, 0, 0.1) 50%, rgba(0, 0, 0, 0.6) 100%);
  display: flex;
  align-items: flex-end;
  justify-content: center;
  padding-bottom: 40px;
}

.banner_text {
  font-size: 28px;
  font-weight: bold;
  color: #fff;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.7);
  background: rgba(0, 122, 255, 0.8);
  padding: 12px 24px;
  border-radius: 6px;
  backdrop-filter: blur(10px);
}

.article_content {
  font-size: 16px;
  line-height: 1.8;
  color: #333;
  margin-bottom: 60px;
  padding: 0 20px;
}

.article_paragraph {
  margin-bottom: 24px;
  text-indent: 2em;
  text-align: justify;
}

.article_paragraph:last-child {
  margin-bottom: 0;
}

.article_navigation {
  display: flex;
  justify-content: space-between;
  margin-top: 60px;
  padding: 40px 20px;
  border-radius: 0 0 8px 8px;
  border-top: 1px solid #D6D6D6;
}

.nav_prev,
.nav_next {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  flex: 1;
  padding: 20px;
  border-radius: 8px;
  transition: all 0.3s ease;
  cursor: pointer;
}

.nav_prev:hover,
.nav_next:hover {
  background: #fff;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  transform: translateY(-2px);
}

.nav_label {
  font-size: 14px;
  color: #666;
  margin-bottom: 8px;
  font-weight: 500;
}

.nav_title {
  font-size: 16px;
  font-weight: bold;
  color: #333;
  text-decoration: none;
  transition: color 0.3s ease;
  line-height: 1.4;
}

.nav_title:hover {
  color: #D5EADA;
}

.good_detial {
  padding: 80px 0;
  background: #fff;
}

.good_detial_container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.product_overview {
  display: flex;
  gap: 60px;
  margin-bottom: 80px;
  background: #fff;
  border-radius: 8px;
  padding: 40px;
}

.product_gallery {
  flex: 1;
  display: flex;
  gap: 20px;
  align-items: flex-start;
}

.thumbnail_list {
  display: flex;
  flex-direction: column;
  gap: 15px;
  width: 100px;
  flex-shrink: 0;
}

.thumbnail_item {
  width: 100px;
  height: 100px;
  border: 2px solid #ddd;
  border-radius: 8px;
  overflow: hidden;
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;
}

.thumbnail_item:hover {
  border-color: #3D6451;
  transform: scale(1.05);
}

.thumbnail_item.active {
  border-color: #3D6451;
}

.thumbnail_image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.3s ease;
}

.thumbnail_item:hover .thumbnail_image {
  transform: scale(1.1);
}

.main_image_container {
  flex: 1;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  position: relative;
  background: #f8f9fa;
  overflow: hidden;
}

.main_image {
  width: 100%;
  object-fit: contain;
  transition: transform 0.3s ease;
}

.main_image_container:hover .main_image {
  transform: scale(1.02);
}

.product_info {
  flex: 1;
  padding: 0 20px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  gap: 20px;
}

.product_title {
  font-size: 28px;
  font-weight: bold;
  color: #333;
  margin-bottom: 0;
  line-height: 1.3;
}

.product_description {
  font-family: Source Han Sans SC, Source Han Sans SC;
  font-weight: 500;
  font-size: 14px;
  color: #3A3A3A;
}

.product_specs {
  display: flex;
  flex-direction: column;
  gap: 15px;
  margin-bottom: 0;
  background: #f8f9fa;
  padding: 20px;
  border-radius: 8px;
}

.spec_item {
  display: flex;
  align-items: center;
  gap: 15px;
  padding: 8px 0;
}

.spec_label {
  font-size: 16px;
  font-weight: 600;
  color: #333;
  min-width: 80px;
}

.spec_value {
  font-size: 14px;
  color: #666;
  font-weight: 500;
}

.inquiry_btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 15px 30px;
  background: #4CAF50;
  color: #fff;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.3s ease;
  font-size: 16px;
  font-weight: 600;
  box-shadow: 0 2px 8px rgba(76, 175, 80, 0.3);
  align-self: flex-start;
  margin-top: auto;
}

.inquiry_btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 16px rgba(76, 175, 80, 0.4);
  background: #45a049;
}

.inquiry_btn span {
  color: #fff;
}

.product_introduction {
  margin-top: 60px;
  padding: 40px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  border: 1px solid #e9ecef;
}

.section_title {
  font-size: 28px;
  font-weight: bold;
  color: #333;
  margin-bottom: 30px;
  text-align: center;
  position: relative;
}

.section_title::after {
  content: '';
  position: absolute;
  bottom: -10px;
  left: 50%;
  transform: translateX(-50%);
  width: 60px;
  height: 3px;
  background: #007AFF;
  border-radius: 2px;
}

.info_table {
  display: flex;
  flex-direction: column;
  gap: 0;
  max-width: 800px;
  margin: 0 auto;
}

.table_row {
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  padding: 20px;
  border-bottom: 1px solid #e9ecef;
  transition: all 0.3s ease;
}

.table_row:last-child {
  border-bottom: none;
}

.table_row:hover {
  background: #f8f9fa;
}

.table_label {
  font-size: 16px;
  font-weight: 600;
  color: #333;
  min-width: 120px;
  padding-right: 30px;
  flex-shrink: 0;
  text-align: left;
}

.table_content {
  font-size: 16px;
  color: #666;
  text-align: left;
  flex: 1;
  line-height: 1.6;
}

.ingredients_efficacy {
  margin-top: 60px;
  padding: 40px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  border: 1px solid #e9ecef;
}

.ingredients_section {
  margin-bottom: 40px;
}

.subsection_title {
  font-size: 24px;
  font-weight: bold;
  color: #333;
  margin-bottom: 30px;
  text-align: center;
  position: relative;
}

.subsection_title::after {
  content: '';
  position: absolute;
  bottom: -10px;
  left: 50%;
  transform: translateX(-50%);
  width: 50px;
  height: 3px;
  background: #007AFF;
  border-radius: 2px;
}

.ingredient_list {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 20px;
  justify-content: center;
}

.ingredient_item {
  background: #f8f9fa;
  padding: 20px;
  border-radius: 8px;
  border: 1px solid #e9ecef;
  transition: all 0.3s ease;
  text-align: center;
}

.ingredient_item:hover {
  transform: translateY(-3px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  border-color: #007AFF;
}

.ingredient_name {
  font-size: 18px;
  font-weight: bold;
  color: #333;
  margin-bottom: 10px;
  position: relative;
}

.ingredient_name::after {
  content: '';
  position: absolute;
  bottom: -5px;
  left: 50%;
  transform: translateX(-50%);
  width: 30px;
  height: 2px;
  background: #007AFF;
  border-radius: 1px;
}

.ingredient_desc {
  font-size: 14px;
  color: #666;
  line-height: 1.6;
  text-align: justify;
}
</style>